module.exports = __webpack_public_path__ + "img/sensor_d.c41bb55b.svg";